const empty = (props) => props.children

export default empty